import { isOnline, lastSeenLabel, parseUtc } from "./constants";

export function LastSeen({ iso, withTime = false }) {
  const online = isOnline(iso);
  const exact = iso ? parseUtc(iso).toLocaleString("ar-SA", { dateStyle: "medium", timeStyle: "short" }) : null;
  return (
    <span className="inline-flex items-center gap-1.5 text-xs" title={exact || ""}>
      <span className={`w-2 h-2 rounded-full ${online ? "bg-[#00A85A] animate-pulse" : iso ? "bg-[#C9C9C9]" : "bg-[#EAEAEA]"}`} />
      <span className={online ? "text-[#00A85A] font-bold" : "text-[#6B6B6B]"}>{lastSeenLabel(iso)}</span>
      {withTime && exact && !online && <span className="text-[#9B9B9B]">· {exact}</span>}
    </span>
  );
}
